import { render } from "./ListScore.vue?vue&type=template&id=4e187c0d"
import script from "./ListScore.vue?vue&type=script&lang=js"
export * from "./ListScore.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__